import Button from "@/common/Components/Button/Button";
import React, {useState, useEffect} from "react";
import axiosInstance from "@/api/axios";
import "../Waste-Dashboard/WasteDashboard.css";
import {AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineClose} from 'react-icons/ai';
import {useContext} from "react";
import {LanguageContext} from "@/context/LanguageContext";
import ImageDisplay from "./Components/Image-Display/ImageDisplay";
import Waste from "./Waste";
import SavingsChart from "@/pages/CO2-Savings/SavingsChart";
import SubclassDisplay from "@/pages/Subclass-Display/SubclassDisplay copy";
import BubbleChart from "@/pages/Waste-Dashboard/Components/Waste-Bubblechart/BubbleChart";
import BinLineChart from "./Components/Bin-Linechart/BinLineChart";
import useId from "./Components/useId";
import WasteGeneration from "./Components/Waste-Generation/WasteGeneration";
import {debounce} from 'lodash';
import MainDashboard from "../Main-Dashboard/MainDashboard";
import CustomCalendar from "../../common/Components/Calendar/Calendar";
import {useTranslation} from "react-i18next";
import WasteGenBinline from "../WasteGeneration-BinlineChart/WasteGenBinline";


const Dashboard = ({id_, wasteitem_, selectedValue_, dayvalue_, datevalue_}) => {
    const wasteitem = wasteitem_ || 'organic';
    const id = id_;
    const [selectedValue, setSelectedValue] = selectedValue_;
    const [dayvalue, setDayValue] = dayvalue_;
    const [selectedButton, setSelectedButton] = useState('year');
    const [binIds, setBinIds] = useState([]);
    const [selectedstream, setSelectedStream] = useState("organic");
    const [selectedChart, setSelectedChart] = useState("waste");
    const [currentWasteItem, setCurrentWasteItem] = useState(wasteitem);
    const [currentbinid, setCurrentBinId] = useState(id);
    const [totalwasteproduced, setTotalWasteProduced] = useState()
    const [colorwaste, setColorWaste] = useState()
    const [percentagechange, setPercentageChange] = useState()
    const {language} = useContext(LanguageContext);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [bin, setBin] = useState()
    const [tier, setTier] = useState('')
    const [TotalWasteWeight, setTotalWasteWeight] = useState('')
    const [datevalue, setDateValue] = datevalue_; // Savings
    const [calendarclick, setCalendarClick] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const {t} = useTranslation();

    useEffect(() => {
        console.log("Current datevalue:", datevalue);
    }, [datevalue]);

    console.log("dash id: ", id);
    console.log("dash id2:", currentbinid);

    const resetDates = () => {
        setDateValue([{
            startDate: null, endDate: null, key: 'selection'
        }]);
    };

    const handleCloseCalendar = () => {
        setCalendarClick(false);
    }
    const handleDateValueChange = (newDateValue) => {
        console.log("handleDateValueChange", newDateValue);
        setDateValue(newDateValue);
        console.log("newhandleDateValueChange", newDateValue[0].endDate);
        setCalendarClick(false);
        setSelectedButton('custom');

    }

    const handleCalendarClick = () => {
        setCalendarClick(!calendarclick);
        setSelectedButton('custom');
    }

    const handleClick = (btnvalue, selectedChart) => {
        if (btnvalue !== 'custom') {
            setDayValue(btnvalue);
            setSelectedButton(btnvalue);
            resetDates();
        }

    };


    useEffect(() => {
        handleClick('year'); // Automatically select the 'year' button
    }, []); // Empty dependency array means it runs only on mount

    useEffect(() => {
        axiosInstance
            .get('/get_bins')
            .then((response) => {
                setBinIds(response.data.map((item) => item.unique_identifier));
                const foundData = response.data.find(item => item.unique_identifier === id);
                console.log('/get_bins', foundData)
                setBin(foundData);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [id]);

    // Fetch waste data
    useEffect(() => {
        const fetchTotalWasteProduced = async () => {
            try {
                const response = await axiosInstance.get("/totalwasteproduced", {
                    params: {
                        wasteitem: currentWasteItem, id: id, day: dayvalue,
                    },
                });

                setPercentageChange(parseFloat(response.data.percentage_change).toFixed(2));
                setColorWaste(response.data.color);
                setTotalWasteProduced(response.data.total_waste);
                setTotalWasteWeight(response.data.waste_weight);

            } catch (error) {
                console.error('Error fetching Total waste data:', error);
            } finally {
                setLoading(false);
            }
        };

        if (!loading) {
            fetchTotalWasteProduced();
        }
    }, [currentWasteItem, id, dayvalue]);

    useEffect(() => {
        const fetchtotalco2savedata = debounce(async () => {
            try {
                const response = await axiosInstance.get('/totalco2saved', {
                    params: {
                        wasteitem: currentWasteItem, id: id, day: dayvalue,
                    },
                }); // Adjust the endpoint
                console.log('/totalco2saved', response)
                setPercentageChange(parseFloat(response.data.percentage_change).toFixed(2))
                setColorWaste(response.data.color)
                setTotalWasteProduced(response.data.total_co2_current)
            } catch (err) {
                console.log(err);
                setError('Something went wrong, please try again later.');
            }
        }, 100); // increase the number if you want the pull frequency reduced

        fetchtotalco2savedata();
    }, [dayvalue, currentWasteItem, id]);


    const handleDropdownChange = (event) => {
        setSelectedStream(event.target.value);
        setCurrentWasteItem(event.target.value);
    };

    const handleChartChange = (event) => {
        setSelectedChart(event.target.value);
    };

    const handleBinDropDownChange = (event) => {
        setCurrentBinId(event.target.value);

    };


    const translations = {
        day: 'dag', week: 'week', month: 'maand', '3months': '3 maanden', '6months': '6 maanden', year: 'jaar'
    };
    const translatedSelectedButton = language === "Dutch" ? translations[selectedButton] : selectedButton;
    const message = `Totaal Afval in Vergelijking Met Vorige ${translatedSelectedButton}`;
    const message1 = `Totaal CO2 Besparing ${translatedSelectedButton}`;
    const message2 = `samenstelling van het substraat ${translatedSelectedButton}`;


    return (
        <div className="bg-white dark:bg-plaex-dark dark:text-white min-h-screen pt-16">
            <div className="sticky top-16 z-30 bg-white dark:bg-plaex-dark shadow-md w-full">
                <div className="px-4 py-4 ">
                    <div className="Waste-Filter-Container px-8">
                        <div className="Waste-Filter-Container-title w-full capitalize flex flex-col gap-4">
                            {/* Updated code starts here */}
                            <div
                                className="Waste-Filter-Container-title sm:flex-col xs:flex-col lg:flex-row md:flex-row text-xl sm:-mt-4 xs:-mt-4 lg:mt-0 md:mt-0 w-full lg:justify-start xs:justify-center sm:justify-center md:justify-start items-center capitalize flex flex-row gap-x-2 sm:gap-y-3 xs:gap-y-3">
                                <div className="flex flex-row lg:flex-row md:flex-row sm:flex-col xs:flex-col space-3">
                                    <span className="pt-1 pr-2 text-xl font-semibold xs:text-center">{id}</span>
                                    <div
                                        className="Filter-Buttons grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-2 w-full mt-2 lg:mt-0">
                                        <select
                                            onChange={handleDropdownChange}
                                            className="border-2 w-full border-plaex-bar flex items-center justify-center rounded-lg text-sm col-span-1"
                                        >
                                            <option
                                                value="organic">{t('organiclabel')}</option>
                                            <option value="PMD">{t('pmdlabel')}</option>
                                            <option value="paper">{t('paperlabel')}</option>
                                            <option
                                                value="residual">{t('residuallabel')}</option>
                                        </select>
                                        <Button
                                            text={t('onedaylabel')}
                                            onClick={(event) => handleClick("day", selectedChart)}
                                            value="day"
                                            className={`w-full ${selectedButton === "day" ? "selected" : ""}`}
                                        />
                                        <Button
                                            text={t('oneweeklabel')}
                                            onClick={(event) => handleClick("week", selectedChart)}
                                            value="week"
                                            className={`w-full ${selectedButton === "week" ? "selected" : ""}`}
                                        />
                                        <Button
                                            text={t('onemonthlabel')}
                                            onClick={(event) => handleClick("month", selectedChart)}
                                            value="month"
                                            className={`w-full ${selectedButton === "month" ? "selected" : ""}`}
                                        />
                                        <Button
                                            text={t('threemonthlabel')}
                                            onClick={(event) => handleClick("3months", selectedChart)}
                                            value="3months"
                                            className={`w-full ${selectedButton === "3months" ? "selected" : ""}`}
                                        />
                                        <Button
                                            text={t('sixmonthlabel')}
                                            onClick={(event) => handleClick("6months", selectedChart)}
                                            value="6months"
                                            className={`w-full ${selectedButton === "6months" ? "selected" : ""}`}
                                        />
                                        <Button
                                            text={t('oneyearlabel')}
                                            onClick={(event) => handleClick("year", selectedChart)}
                                            value="year"
                                            className={`w-full ${selectedButton === "year" ? "selected" : ""}`}
                                        />
                                        <Button
                                            text={t('customlabel')}
                                            onClick={(event) => handleCalendarClick()}
                                            value="custom"
                                            className={selectedButton === 'custom' ? 'selected' : ''}
                                            on
                                        />

                                    </div>
                                </div>
                            </div>
                            {/* Updated code ends here */}
                        </div>

                        {calendarclick && (
                            <div
                                className={
                                    calendarclick
                                        ? "z-50 flex flex-col bg-white rounded-lg shadow-lg absolute top-0 w-full"
                                        : "z-50 flex flex-col rounded-lg shadow-lg absolute w-full bg-white"
                                }
                            >
                                <div className="flex items-start justify-start">
                                    <button
                                        onClick={handleCloseCalendar}
                                        className="text-2xl font-black ml-6 mt-6 hover:text-plaex-bar transition-transform duration-300 ease-in-out transform hover:scale-[0.8] "
                                    >
                                        <AiOutlineClose/>
                                    </button>
                                </div>
                                <CustomCalendar datevalue={datevalue} onDateValueChange={handleDateValueChange}/>
                            </div>
                        )}
                        {
                            // <div
                            //     className="Filter-Buttons grid lg:grid-cols-8 md:grid-cols-5 sm:grid-cols-4 xs:grid-cols-3 lg:w-auto md:w-auto xs:w-full sm:w-full sm:px-5 xs:px-5 lg:px-0 md:px-0">
                            //
                            //     {
                            //         /*
                            //      <Button
                            //         text={language === "Dutch" ? "Aangepast" : "Custom "}
                            //         onClick={(event) => handleCalendarClick()}
                            //         value="custom"
                            //         className={selectedButton === 'custom' ? 'selected' : ''}
                            //     />
                            //
                            //      */
                            //     }
                            //
                            // </div>
                        }
                    </div>
                </div>
            </div>

            <div className="px-4 lg:px-8 pt-6">

                <Waste
                    id={id}
                    currentWasteItem={currentWasteItem}
                    dayvalue={dayvalue}
                    language={language}
                    message1={message2}
                    selectedButton={selectedButton}
                    colorwaste={colorwaste}
                    percentagechange={percentagechange}
                    TotalWasteWeight={TotalWasteWeight}
                    selectedValue={selectedValue}
                    setSelectedValue={setSelectedValue}
                    datevalue={datevalue}
                />
                <SavingsChart
                    id={id}
                    currentWasteItem={currentWasteItem}
                    dayvalue={dayvalue}
                    language={language}
                    message1={message1}
                    selectedButton={selectedButton}
                    totalwasteproduced={totalwasteproduced}
                    colorwaste={colorwaste}
                    percentagechange={percentagechange}
                    datevalue={datevalue}
                />
                <WasteGenBinline
                    id={id}
                    wasteitem={currentWasteItem}
                    dayvalue={dayvalue}
                    datevalue={datevalue}
                    selectedButton={selectedButton}
                    currentWasteItem_={currentWasteItem}
                    dayvalue_={dayvalue}
                    datevalue_={datevalue}
                    selectedButton_={selectedButton}
                    selectedButton={selectedButton}
                    setSelectedValue_={setSelectedValue}
                    bin_={bin}
                    language={language}
                    TotalWasteWeight={TotalWasteWeight}
                />
                <BubbleChart
                    id={id}
                    currentWasteItem={currentWasteItem}
                    dayvalue={dayvalue}
                    language={language}
                    message1={message2}
                    selectedButton={selectedButton}
                    totalwasteproduced={totalwasteproduced}
                    colorwaste={colorwaste}
                    percentagechange={percentagechange}
                    TotalWasteWeight={TotalWasteWeight}
                    datevalue={datevalue}
                />
                <SubclassDisplay
                    id={id}
                    currentWasteItem={currentWasteItem}
                    dayvalue={dayvalue}
                    language={language}
                    message1={message2}
                    selectedButton={selectedButton}
                    totalwasteproduced={totalwasteproduced}
                    colorwaste={colorwaste}
                    percentagechange={percentagechange}
                    TotalWasteWeight={TotalWasteWeight}
                    datevalue_={datevalue}
                    currentWasteItem_={currentWasteItem}
                />
            </div>
        </div>
    )
}

export default Dashboard



